import { render, staticRenderFns } from "./_ArchivedCompanies.vue?vue&type=template&id=57be12ea&"
import script from "./_ArchivedCompanies.vue?vue&type=script&lang=ts&"
export * from "./_ArchivedCompanies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports